import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../../util/reactIntl';
import { InlineTextButton } from '../../../components';
import css from './ReportListingButton.module.css';

const ReportListingButton = props => {
    const { className, rootClassName, onReportClicked } = props;
    const classes = classNames(rootClassName || css.root, className);

    return (
        <div className={classes}>
            <InlineTextButton className={css.reportButton} onClick={onReportClicked}>
                <FormattedMessage id="ReportListingButton.report" defaultMessage="Report this listing" />
            </InlineTextButton>
        </div>
    );
};

export default ReportListingButton;
